import React from 'react'
import { connect } from 'react-redux';
import { languageSelector } from '../../../../Redux/Reducers/settingsReducer';
import {
  getOrdersChart,
  ordersChartSelector
} from '../../../../Redux/Reducers/chartsReducer';
import { localization } from '../../../../Utils/Localization/localization';
import classes from './ReportsPage.module.scss';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip } from 'recharts';
import { Button } from 'antd';

interface StateProps {
  language: string,
  ordersChartData: []
}
interface DispatchProps {
  getOrdersChart: () => void
}
interface Props extends StateProps, DispatchProps { }

function ReportsPage(props: Props) {
  const [grid, setGrid] = React.useState(false);

  React.useEffect(() => {
    props.getOrdersChart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.ReportsPage}>
      <h2>{localization('reports', props.language)}</h2>
      <h3>{localization('monthsReport', props.language)}</h3>
      <Button onClick={() => setGrid(!grid)} >{localization('grid', props.language)}</Button>
      <LineChart
        data={props.ordersChartData}
        width={600}
        height={400}
        className={classes.Chart}
      >
        <Line type={'linear'} dataKey={'count'} stroke={'#000'} />
        <XAxis dataKey={'name'} />
        {
          grid &&
          <CartesianGrid stroke={'#000'} strokeDasharray="5 5" />
        }
        <YAxis />
        <Tooltip />
      </LineChart>
    </div>
  );
}

function mapStateToProps(state: any) {
  return {
    language: languageSelector(state),
    ordersChartData: ordersChartSelector(state)
  }
}
const mapDispatchToProps = {
  getOrdersChart
}

const ConnectedReportsPage = connect(mapStateToProps, mapDispatchToProps)(ReportsPage);
export { ConnectedReportsPage as ReportsPage };